import { styled } from "@mui/system";
import { Typography } from "@mui/material";

export const LogoSubtitle = styled(Typography)({
    fontSize: "14px",
    color: "var(--community-color-secondary-text)",
});
